import { render, staticRenderFns } from "./contactdocument-close-flie.vue?vue&type=template&id=22d4e433&scoped=true&"
import script from "./contactdocument-close-flie.vue?vue&type=script&lang=js&"
export * from "./contactdocument-close-flie.vue?vue&type=script&lang=js&"
import style0 from "./contactdocument-close-flie.vue?vue&type=style&index=0&id=22d4e433&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d4e433",
  null
  
)

export default component.exports